import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainVolumeFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om een volume reeksen toe te voegen. De waarden uit het bestand worden
        ingeladen in het formulier. Op deze manier kunt u eenvoudig meerdere perioden toevoegen.
        Zorg ervoor dat u het format in het volgende template hanteert.
      </Text>
      <Button
        mb={4}
        variant="primary"
        onClick={() =>
          downloadFile("/files/gpdVolumeReeksTemplate.xlsx", "gpdVolumeReeksTemplate.xlsx")
        }
      >
        Download Excel-template
      </Button>
    </>
  );
};
